class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    // Listen for input events on all facet forms
    document.querySelectorAll('form[id^="FacetFilters"]').forEach(form => {
      form.addEventListener('input', this.debouncedOnSubmit.bind(this));
    });

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer){
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop){
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    console.log('---------------------------', url)
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        
        // Parse the HTML once
        const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
        
        // Update product grid container instead of just the grid
        const productGridContainer = parsedHTML.getElementById('ProductGridContainer');
        if (productGridContainer) {
          document.getElementById('ProductGridContainer').innerHTML = productGridContainer.innerHTML;
        }

        // Update filters
        FacetFiltersForm.renderFilters(parsedHTML, event);
        
        // Update counts
        const countElement = parsedHTML.getElementById('ProductCount');
        if (countElement) {
          const container = document.getElementById('ProductCount');
          const containerDesktop = document.getElementById('ProductCountDesktop');
          if (container) {
            container.innerHTML = countElement.innerHTML;
            container.classList.remove('loading');
          }
          if (containerDesktop) {
            containerDesktop.innerHTML = countElement.innerHTML;
            containerDesktop.classList.remove('loading');
          }
        }

        // Remove loading states
        const collections = document.querySelectorAll('.collection');
        collections.forEach(collection => {
          collection.classList.remove('loading');
        });

        // Remove loading overlay
        const loadingOverlays = document.querySelectorAll('.loading-overlay');
        loadingOverlays.forEach(overlay => {
          overlay.style.display = 'none';
        });
      })
      .catch((error) => {
        console.error('Error:', error);
        // Remove loading states on error
        document.querySelectorAll('.collection').forEach(collection => {
          collection.classList.remove('loading');
        });
        document.querySelectorAll('.loading-overlay').forEach(overlay => {
          overlay.style.display = 'none';
        });
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    // Update product grid container
    const productGridContainer = parsedHTML.getElementById('ProductGridContainer');
    if (productGridContainer) {
      document.getElementById('ProductGridContainer').innerHTML = productGridContainer.innerHTML;
    }

    // Update filters
    FacetFiltersForm.renderFilters(parsedHTML, event);
    
    // Update counts
    const countElement = parsedHTML.getElementById('ProductCount');
    if (countElement) {
      const container = document.getElementById('ProductCount');
      const containerDesktop = document.getElementById('ProductCountDesktop');
      if (container) {
        container.innerHTML = countElement.innerHTML;
        container.classList.remove('loading');
      }
      if (containerDesktop) {
        containerDesktop.innerHTML = countElement.innerHTML;
        containerDesktop.classList.remove('loading');
      }
    }

    // Remove loading states
    const collections = document.querySelectorAll('.collection');
    collections.forEach(collection => {
      collection.classList.remove('loading');
    });

    // Remove loading overlay
    const loadingOverlays = document.querySelectorAll('.loading-overlay');
    loadingOverlays.forEach(overlay => {
      overlay.style.display = 'none';
    });
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    })

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      const sourceElement = html.querySelector(selector);
      const targetElement = document.querySelector(selector);
      if (!sourceElement || !targetElement) return;
      targetElement.innerHTML = sourceElement.innerHTML;
    });

    // Add null check for mobile form
    const mobileForm = document.getElementById('FacetFiltersFormMobile');
    const menuDrawer = mobileForm?.closest('menu-drawer');
    if (menuDrawer && typeof menuDrawer.bindEvents === 'function') {
      menuDrawer.bindEvents();
    }
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    const entries = Array.from(formData.entries());
    
    // Only include form data if there are actual values
    if (entries.length === 0) return null;
    
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    
    // Add loading states
    document.querySelectorAll('.collection').forEach(collection => {
      collection.classList.add('loading');
    });
    document.querySelectorAll('.loading-overlay').forEach(overlay => {
      overlay.style.display = 'block';
    });

    // Get all forms including drawer forms
    const forms = [];
    const formData = new FormData();

    console.log('onSubmitHandler', event)

    // Handle checkbox/radio input changes
    if (event.target.type === 'checkbox' || event.target.type === 'radio') {
      const form = event.target.closest('form');
                console.log('onSubmitHandler 1', form)

      if (form) {
        forms.push(this.createSearchParams(form));
      }
    } else {
      // Get all relevant forms
      document.querySelectorAll(`
        #FacetFiltersForm,
        #FacetSortForm,
        #FacetFiltersFormDrawer,
        #FacetSortFormDrawer,
        #FacetFiltersDrawerFormMobile,
        #FacetSortDrawerForm
      `).forEach(form => {
                        console.log('onSubmitHandler 2', form)

        const params = this.createSearchParams(form);
        if (params) {
          forms.push(params);
        }
      });
    }

    console.log('onSubmit 3', forms)

    // Submit and update the page
    this.onSubmitForm(forms.join('&'), event);
    
    // Close drawer
    const drawer = document.querySelector('.facets-drawer');
    if (drawer && drawer.classList.contains('active')) {
      drawer.classList.remove('active');
      document.querySelector('.facets-drawer-overlay').classList.remove('active');
      document.body.style.overflow = '';
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

class FacetsDrawer extends HTMLElement {
  constructor() {
    super();
    this.drawer = document.querySelector('.facets-drawer');
    this.overlay = document.querySelector('.facets-drawer-overlay');
    this.openButtons = document.querySelectorAll('.facets-drawer-trigger');
    this.closeButton = this.drawer.querySelector('.facets-drawer__close');
    
    this.bindEvents();
  }

  bindEvents() {
    this.openButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.stopPropagation();
        this.openDrawer();
      });
    });

    this.closeButton.addEventListener('click', (e) => {
      e.stopPropagation();
      this.closeDrawer();
    });
    
    this.overlay.addEventListener('click', (e) => {
      e.stopPropagation();
      this.closeDrawer();
    });

    // Prevent drawer from closing when clicking inside it
    this.drawer.addEventListener('click', (e) => {
      e.stopPropagation();
    });
    
    // Close on escape key
    document.addEventListener('keyup', (event) => {
      if (event.code === 'Escape') this.closeDrawer();
    });

    // Close when clicking outside
    document.addEventListener('click', (event) => {
      if (this.drawer.classList.contains('active') && 
          !this.drawer.contains(event.target) && 
          ![...this.openButtons].some(button => button.contains(event.target))) {
        this.closeDrawer();
      }
    });
  }

  openDrawer() {
    this.drawer.classList.add('active');
    this.overlay.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  closeDrawer() {
    this.drawer.classList.remove('active');
    this.overlay.classList.remove('active');
    document.body.style.overflow = '';
  }
}

customElements.define('facets-drawer', FacetsDrawer);
// Initialize FacetsDrawer when DOM is loaded
window.addEventListener('DOMContentLoaded', () => {
  if (!customElements.get('facets-drawer')) {
    customElements.define('facets-drawer', FacetsDrawer);
  }
  // Create instance of FacetsDrawer
  new FacetsDrawer();
});

